(function ($) {
    const filterSubmitButton = $('.filter-update-button');
    const filterContainer = $('.filter-container');
    const checkboxes = $('.checkbox-input');

    /**
     * Request new work posts, and update the main content with them.
     * @param e Event
     */
    const filterWork = (e) => {
        e.preventDefault();
        loadWork();
    };

    /**
     * Request new categories based on the categories string.
     */
    const loadWork = () => {
        $.ajax({
            url: vi.ajax_url,
            type: 'GET',
            data: {
                security: vi.security,
                action: 'work_filter',
                categories: getCategoriesString(),
            },
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            success: function (result) {
                document.querySelector('.js-work-container').innerHTML = result.content;
            },
            error: function (error) {
                console.log('error :( ');
            }
        })
    };

    /**
     * Set the "Update Filter" button link with the selected categories.
     */
    const setFilterUrl = () => {
        filterSubmitButton.attr('href', '?work-categories=' + getCategoriesString());
    };

    /**
     * Return string of selected categories.
     * @returns {string}
     */
    const getCategoriesString = () => {
        const checkedCheckboxes = document.querySelectorAll('.checkbox-input:not([value="all"]):checked');

        return [...checkedCheckboxes]
            .map((item) => item.getAttribute('id'))
            .join('+');
    };

    /**
     * Handles when checkboxes are changed.
     */
    const handleCheckboxes = (e) => {
        const thisCheckbox = $(e.currentTarget);
        const all = $('.checkbox-input[value="all"]');
        const categories = $('.checkbox-input:not([value="all"])');
        const checkedCategories = $('.checkbox-input:checked:not([value="all"])');

        if (thisCheckbox[0] === all[0]) {
            categories.prop('checked', thisCheckbox.is(':checked'));

        } else {
            all.prop('checked', checkedCategories.length === categories.length);
        }

        // Update filter submit button.
        setFilterUrl();
    };

    /**
     * Event listeners
     */
    filterSubmitButton.on('click', filterWork);
    checkboxes.on('change', handleCheckboxes);

    window.addEventListener('popstate', function (e) {
        if (e.state && e.state.type === 'work') {

            loadPostsData(e.state, function (result) {
                terms.removeClass('active');
                $(`[data-slug=${e.state}]`).addClass('active');
                document.querySelector('.js-posts-container').innerHTML = result.content;
            });

        }
    });

})(jQuery);
